<div class="relative">
  <button
    #trigger
    type="button"
    (click)="toggleOpen(); $event.stopPropagation()"
    (keydown.arrowDown)="openFromKeyboard($event)"
    class="w-full inline-flex items-center justify-between gap-1.5 rounded-md border border-border bg-background px-3 py-1.5 min-h-11 text-caption font-medium text-primary hover:bg-grey-100 transition-nike focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus"
    [attr.aria-expanded]="isOpen()"
    [attr.aria-controls]="isOpen() ? listId : null"
    aria-haspopup="listbox"
    aria-label="Select company">
    <span class="max-w-35 truncate">{{ selectedName() ?? 'Select company' }}</span>
    <svg
      class="h-4 w-4 shrink-0 text-secondary transition-transform duration-200"
      [class.rotate-180]="isOpen()"
      fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
    </svg>
  </button>

  @if (isOpen()) {
    <!-- Keyboard: Up/Down/Home/End move, Enter/Space choose, Escape or Tab close. -->
    <ul
      #list
      [id]="listId"
      role="listbox"
      aria-label="Companies"
      (keydown)="onListKeydown($event)"
      class="absolute left-0 top-full mt-1 z-50 min-w-50 max-w-70 rounded-md border border-border bg-background shadow-md py-1 overflow-auto max-h-60">
      @for (company of companies(); track company.id) {
        <li
          role="option"
          tabindex="-1"
          [attr.aria-selected]="companyContext.selected()?.id === company.id"
          (click)="select(company)"
          class="flex items-center px-4 py-2.5 min-h-11 cursor-pointer text-caption text-primary hover:bg-grey-100 focus:bg-grey-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-focus transition-nike"
          [class.font-medium]="companyContext.selected()?.id === company.id">
          {{ company.name }}
        </li>
      }
      @if (companies().length === 0) {
        <li class="px-4 py-2.5 text-caption text-secondary">No companies found.</li>
      }
    </ul>
  }
</div>
